<template>
  <!--<div>-->
    <div class="page-content">
      <!-- コンテンツ情報表示前 -->
      <div class="inner" v-if="!contents" />
      <div class="inner" v-show="contents">
        <!-- お知らせ -->
        <div id="store-news-container" class="iframe-container" v-show="!isCarrier(platformName) && showNews">
          <iframe id="store-news" :src="newsUrl" scrolling="no" frameborder="0"></iframe>
        </div>

        <template v-if="contents">
          <!-- コンテンツ情報あり -->
          <template class="inner" v-if="0 < contents.length">
            <div class="card-row" v-for="(detail, index) in contents" :key="detail.contentid">
              <!-- 奇数行 -->
              <div class="card-grid" v-if="(index % 2) == 0">
                <!-- コンテンツ大表示 -->
                <div class="container group1">
                  <StoreListItem :contentsDetail="detail[0]" gridType="group1" @showDetail="showDetail" />
                </div><!-- container group1 -->
                <div class="container group2" v-if="detail[1]">
                  <!-- コンテンツ中表示 -->
                  <div class="grid1">
                    <StoreListItem :contentsDetail="detail[1]" gridType="group2_grid1" @showDetail="showDetail" />
                  </div>
                  <!-- コンテンツ小表示 -->
                  <div class="grid2" v-if="detail[2]">
                    <StoreListItem :contentsDetail="detail[2]" gridType="group2_grid2" @showDetail="showDetail" />
                    <StoreListItem :contentsDetail="detail[3]" gridType="group2_grid2" @showDetail="showDetail" v-if="detail[3]" />
                  </div>
                </div><!-- container group2 -->
              </div><!-- card-grid -->
              <!-- 偶数行 -->
              <div class="card-grid" v-else>
                <div class="container group2">
                  <!-- コンテンツ中表示 -->
                  <div class="grid1">
                    <StoreListItem :contentsDetail="detail[0]" gridType="group2_grid1" @showDetail="showDetail" />
                  </div>
                  <!-- コンテンツ小表示 -->
                  <div class="grid2" v-if="detail[1]">
                    <StoreListItem :contentsDetail="detail[1]" gridType="group2_grid2" @showDetail="showDetail" />
                    <StoreListItem :contentsDetail="detail[2]" gridType="group2_grid2" @showDetail="showDetail" v-if="detail[2]" />
                  </div>
                </div><!-- container group2 -->
                <!-- コンテンツ大表示 -->
                <div class="container group1" v-if="detail[3]">
                  <StoreListItem :contentsDetail="detail[3]" gridType="group1" @showDetail="showDetail" />
                </div><!-- container group1 -->
              </div><!-- card-grid -->
            </div><!-- v-for(contents) -->
          </template>

          <!-- コンテンツ情報なし -->
          <template class="inner" v-else>
            <div class="no-contents">
              <div class="align-center">
                <p class="font24">購入可能なコンテンツがありません</p>
                <p>購入済みコンテンツより学習をスタートできます。</p>
              </div>
              <div class="content-button">
                <button type="button" @click="doChangeView">コンテンツを確認する</button>
              </div>
            </div><!-- no-contents -->
          </template>
        </template>

      </div>
    </div><!-- page-content -->
  <!--</div>-->
</template>

<script>
import StoreListItem from "@/components/store/StoreListItem";
import common from "@/mixin/common";
import http from "@/mixin/http";
import * as constants from "@/mixin/constants";

const COLUMN_COUNT = 4;

export default {
  name: "storeList",
  props: {
    platformName: String
  },
  data: function() {
    return {
      contents: null,
      productId: "",
      gridType: "",
      contentName: "",
      contentId: "",
      showNews: false
    };
  },
  components: {
    StoreListItem
  },
  mixins: [
    common,
    http
  ],
  computed: {
    isMobile: () => window.hasOwnProperty(constants.MOBILE_INTERFACE_NAME),
    newsUrl: function() {
      if (this.isMobile) {
        return process.env.STORE_NOTICE_URL_SP;
      } else {
        return process.env.STORE_NOTICE_URL_PC;
      }
    }
  },
  created: function() {
    this.log("StoreList start created");
    this.$emit("setViewName", "ストア");
  },
  mounted: function() {
    this.log("StoreList start mounted");

    // コンテンツ一覧情報を取得し画面に設定する
    this.setContents();
    // お知らせの設定
    this.setNews();
  },
  methods: {
    /**
     * コンテンツ一覧情報を取得し画面に設定する
     */
    setContents: async function() {
      var self = this;
      this.log("StoreList start setContents");
      this.contents = null;

      this.getUserRegistrationInfo();

      if (this.isPlatformiOS(this.platformName)) {
        var accessKey = await storage_wrapper.getRsAccessKey();
        if (!accessKey) {
          // コンテンツマスタ情報一覧を取得し画面に設定する
          self.setMasterContent();
          return;
        }
      }

      // 購入済みコンテンツ更新APIを実行
      this.updateContentList().then(function(response) {
        self.log("StoreList updateContentList result_code: " + response.result_code);
        switch (response.result_code) {
          case "INFO_INVALID_ACCESSKEY":
            self.showErrorInvalidAccessKey();
            break;
          default:
            // コンテンツ情報一覧取得APIを実行
            self.getContentList().then(function(response) {
              self.log("StoreList getContentList result_code: " + response.result_code);
              self.commonSetContents(response);
            }).catch(function(err) {
              self.log("StoreList setContents error");
              self.contents = [];
              self.$emit("setMenuVisible", false);
            });
            break;
        }
      }).catch(function(err) {
        self.log("StoreList setContents error");
        self.contents = [];
        self.$emit("setMenuVisible", false);
      });
    },
    /**
     * コンテンツマスタ情報一覧を取得し画面に設定する
     */
    setMasterContent: function() {
      this.log("StoreList start setMasterContent");
      const self = this;

      // コンテンツマスタ情報一覧取得APIを実行
      this.getMasterContentList().then(function(response) {
        self.commonSetContents(response);
      }).catch(function(err) {
        self.log("StoreList setMasterContent error");
        self.contents = [];
        self.$emit("setMenuVisible", false);
      });
    },
    /**
     * コンテンツ設定共通処理（コンテンツ情報一覧／コンテンツマスタ情報一覧取得後の共通処理）
     */
    commonSetContents: function(response) {
      this.log("common commonSetContents result_code: " + response.result_code);
      const self = this;

      switch (response.result_code) {
        case "OK":
          var nonPurchased = [];
          var push = Array.prototype.push;
          for (var category of response.categories) {
            push.apply(nonPurchased, category.contents.filter(function(content) { return self.isVisibleContent(content); }));
          }
          self.setContentList(nonPurchased);
          break;
        case "INFO_INVALID_ACCESSKEY":
          self.showErrorInvalidAccessKey();
          break;
        default:
          self.contents = [];
          self.$emit("setMenuVisible", false);
          break;
      }
    },
    /**
     * コンテンツを画面に表示するか否かを返す
     *
     * @param {Object} content コンテンツ情報
     * @return {Boolean} true：表示する, false：表示しない
     */
    isVisibleContent: function(content) {
      // 購入済みコンテンツは表示しない
      if (content.purchased) {
        this.$emit("setMenuVisible", true);
        return false;
      }
      // ストア非表示コンテンツは表示しない
      if (!content.storevisible) {
        return false;
      }
      // 非表示コンテンツは表示しない
      if (this.isInvisibleContent(content.contentid)) {
        return false;
      }
      // iOSの場合
      if (this.isPlatformiOS(this.platformName)) {
        // iOS非表示コンテンツは表示しない
        if (constants.INVISIBLE_CONTENTS_IOS.includes(content.contentid)) {
          return false;
        }
      }
      // 上記以外は表示する
      return true;
    },
    /**
     * コンテンツ一覧情報を画面に設定する
     *
     * @param {Array} contents コンテンツ一覧情報
     */
    setContentList: function(contents) {
      this.log("StoreList start setContentList");
      this.contents = [];
      var row = [];

      for (var content of contents) {
        if (row.length < COLUMN_COUNT) {
          row.push(content);
        } else {
          this.contents.push(row);
          row = [];
          row.push(content);
        }
      }
      if (0 < row.length) {
        this.contents.push(row);
      }
    },
    /**
     * アクセスキー無効エラーダイアログ表示
     */
    showErrorInvalidAccessKey: function() {
      var message = "INFO_INVALID_ACCESSKEY";
      var buttonKind = constants.ERROR_BUTTON_KIND_LOGIN;
      this.$emit("showError", message, buttonKind);
    },
    /**
     * 詳細画面を表示する
     *
     * @param {Object} contentsDetail コンテンツ情報
     */
    showDetail: function(contentsDetail) {
      this.log("StoreList start showDetail");
      this.log("isMobile: " + this.isMobile);

      // GoogleAnalyticsイベントヒット送信
      rosettaGA.sendEvent(
        this.getGaEventCategoryByPlatformName(constants.GA_EVENT.GATEGORY.STORE, this.platformName),
        constants.GA_EVENT.ACTION.CLICK,
        contentsDetail.content_name,
        [contentsDetail.contentid]
      );

      if (this.isMobile) {
        // モバイルアプリコールバック設定
        ROSETTA_onContentPrice = this.ROSETTA_onContentPrice;
        // プロダクトID取得
        this.productId = this.getProductId(contentsDetail);

        this.contentName = contentsDetail.content_name;
        this.contentId = contentsDetail.contentid;

        window.Phone.GetContentPrice(this.productId);
      } else {
        this.showEcSite(contentsDetail);
      }
    },
    /**
     * ECサイト表示処理
     *
     * @param {Object} contentsDetail コンテンツ情報
     */
    showEcSite: function(contentsDetail) {
      var url = contentsDetail.ecurl;
      this.log("StoreList start showEcSite url: " + url);
      window.open(url);
    },
    /**
     * プロダクトID取得処理
     *
     * @param {Object} contentsDetail コンテンツ情報
     */
    getProductId: function(contentsDetail) {
      this.log("StoreDetail start getProductId");
      var mobilePlatformName = window.Phone.GetPlatformName();
      this.log("MobilePlatformName: " + mobilePlatformName);
      switch (mobilePlatformName) {
        case constants.PLATFORM_ANDROID:
          return contentsDetail.productid_playstore;
        case constants.PLATFORM_IOS:
          return contentsDetail.productid_appstore;
        default:
          return null;
      }
    },
    /**
     * モバイルアプリコールバック：コンテンツ価格取得
     *
     * @param {String} price コンテンツ価格
     */
    ROSETTA_onContentPrice: async function(price) {
      this.log("ROSETTA_onContentPrice start price: " + price);

      var mobilePlatformName = window.Phone.GetPlatformName();
      var accessKey = await storage_wrapper.getRsAccessKey();
      var name = encodeURIComponent(this.contentName);
      // Adjust機能は削除となったため空文字とする(コンテンツの詳細ページはSN様画面となるため、変数は残しておく)
      var dispAdjustToken = "";
      var revenueAdjustToken = "";

      var url = process.env.STORE_DETAIL_URL;
      var query = "?Name=" + name
                + "&Price=" + price
                + "&ContentsID=" + this.contentId
                + "&AccessKey=" + accessKey
                + "&ProductID=" + this.productId
                + "&Platform=" + mobilePlatformName
                + "&DispAdjustEvent=" + dispAdjustToken
                + "&RevenueAdjustEvent=" + revenueAdjustToken;

      var page = url + query;

      this.log("Page to go: " + page);
      window.location.replace(page);
    },
    /**
     * 画面遷移する
     */
    doChangeView: function() {
      this.$emit("changeView", "PurchasedList");
    },
    /**
     * 不明なエラーダイアログ表示
     */
    showErrorUnknown: function() {
      let message = constants.ERR_UNKNOWN;
      let buttonKind = "";
      this.$emit("showError", message, buttonKind);
    },
    /**
     * お知らせの設定
     */
    setNews: async function() {
      this.showNews = await this.isAccessUrl(this.newsUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "src/assets/style/common";
@import "src/assets/style/store_list";
</style>



// WEBPACK FOOTER //
// StoreList.vue?1036baf8